module.exports = __webpack_public_path__ + "static/media/rmc_background.489f825f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rmc_background.jpg
// module id = 487
// module chunks = 34